"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = observableStore;

var _rxjs = require("rxjs");

function observableStore(store) {
  return _rxjs.Observable.create(function (observer) {
    store.subscribe(function () {
      observer.next(store.getState());
    });
  });
}